import { useCall } from 'apprise-frontend-core/client/call'
import { tagType } from 'apprise-frontend-tags/constants'


export const tagservice = tagType

export const useTagService = () => useCall(tagservice)